import React, { useEffect, useState } from 'react';
import { ArrowLeft2, ArrowRight2, ArrowDown2, Maximize4 } from 'iconsax-react';
import { TIPO, ORE, apiToViewEvento, toDayRange } from './mockData';

function CollapseIcon({ color = '#666' }) {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M9 3H5a2 2 0 00-2 2v4M15 3h4a2 2 0 012 2v4M9 21H5a2 2 0 01-2-2v-4M15 21h4a2 2 0 002-2v-4"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function PagatoBadge({ pagato }) {
    if (pagato) return (
        <span style={{ fontSize: 11, fontWeight: 600, background: '#00A15D', color: '#fff', borderRadius: 3, padding: '2px 8px', whiteSpace: 'nowrap' }}>Pagato</span>
    );
    return (
        <span style={{ fontSize: 11, fontWeight: 600, background: 'rgba(255,94,75,0.08)', color: '#FF5E4B', border: '1px solid rgba(255,94,75,0.35)', borderRadius: 3, padding: '2px 8px', whiteSpace: 'nowrap' }}>Non pagato</span>
    );
}

function OraCard({ event, colore, tipoKey, onEventClick }) {
    return (
        <div
            onClick={() => onEventClick && onEventClick({ ...event, type: tipoKey })}
            style={{
                background: '#fff', borderLeft: `4px solid ${colore}`,
                borderRadius: '0 4px 4px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                marginBottom: 10, display: 'flex', alignItems: 'stretch',
                overflow: 'hidden', cursor: 'pointer', transition: 'box-shadow 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07)'}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '12px', minWidth: 46, flexShrink: 0 }}>
                <span style={{ fontSize: 18, fontWeight: 800, color: '#222', lineHeight: 1 }}>{event.giorno}</span>
                <span style={{ fontSize: 10, fontWeight: 600, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 2 }}>{event.mese}</span>
            </div>
            <div style={{ width: 1, background: '#f0f0f0', flexShrink: 0 }} />
            <div style={{ padding: '12px 14px', flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', marginBottom: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {event.titolo}
                </div>
                <div style={{ fontSize: 12, color: '#999', marginBottom: 9 }}>{event.oraInizio} - {event.oraFine}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#aaa', border: '1px solid #e8e8e8', borderRadius: 3, padding: '2px 7px', background: '#fafafa' }}>
                        <span style={{ width: 8, height: 8, borderRadius: '50%', border: '1.5px solid #ccc', display: 'inline-block', flexShrink: 0 }} />
                        {tipoKey === 'generico' ? 'Generico' : (event.tipologia || '—')}
                    </span>
                    {tipoKey !== 'generico' && <PagatoBadge pagato={event.pagato} />}
                </div>
            </div>
        </div>
    );
}

function TimeControls({ oraStart, oraEnd, setOraStart, setOraEnd, navigate, collapseIcon }) {
    const selStyle = {
        border: '1px solid #e0e0e0', borderRadius: 4, padding: '5px 8px',
        fontSize: 13, fontWeight: 600, color: '#333', background: '#fff',
        cursor: 'pointer', outline: 'none', appearance: 'none', paddingRight: 24,
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {collapseIcon}
            <div style={{ position: 'relative' }}>
                <select value={oraStart} onChange={e => setOraStart(e.target.value)} style={selStyle}>
                    {ORE.map(h => <option key={h} value={h}>{h}</option>)}
                </select>
                <ArrowDown2 size={12} color="#aaa" style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
            </div>
            <div style={{ position: 'relative' }}>
                <select value={oraEnd} onChange={e => setOraEnd(e.target.value)} style={selStyle}>
                    {ORE.map(h => <option key={h} value={h}>{h}</option>)}
                </select>
                <ArrowDown2 size={12} color="#aaa" style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
            </div>
            <button onClick={() => navigate(-1)} style={navBtn}><ArrowLeft2  size={14} color="#555" /></button>
            <button onClick={() => navigate(1)}  style={navBtn}><ArrowRight2 size={14} color="#555" /></button>
        </div>
    );
}

// Filtra eventi nell'intervallo orario e li raggruppa per tipo
function groupByType(eventi, oraStart, oraEnd) {
    const [sh, sm] = oraStart.split(':').map(Number);
    const [eh, em] = oraEnd.split(':').map(Number);
    const startMin = sh * 60 + sm;
    const endMin   = eh * 60 + em;

    const groups = { impianti: [], lezioni: [], corsi: [], generici: [] };
    (eventi || []).forEach(ev => {
        const v = apiToViewEvento(ev);
        const [evh, evm] = v.oraInizio.split(':').map(Number);
        const evMin = evh * 60 + evm;
        if (evMin >= startMin && evMin < endMin) {
            if (ev.type === 'impianto') groups.impianti.push(v);
            else if (ev.type === 'lezione') groups.lezioni.push(v);
            else if (ev.type === 'corso')   groups.corsi.push(v);
            else groups.generici.push(v);
        }
    });
    return groups;
}

const COLS = [
    { key: 'impianti', label: 'Impianti',        tipoKey: 'impianto' },
    { key: 'lezioni',  label: 'Lezioni',         tipoKey: 'lezione'  },
    { key: 'corsi',    label: 'Corsi e squadre', tipoKey: 'corso'    },
];

function VistaNormale({ oraStart, oraEnd, setOraStart, setOraEnd, navigate, onExpand, onEventClick, groups, dataLabel }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px 14px', borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#222', textTransform: 'capitalize' }}>{dataLabel}</span>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#222' }}>·</span>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#222' }}>Prossimi eventi</span>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#FF5E4B' }}>{oraStart}-{oraEnd}</span>
                </div>
                <TimeControls oraStart={oraStart} oraEnd={oraEnd} setOraStart={setOraStart} setOraEnd={setOraEnd} navigate={navigate} collapseIcon={null} />
            </div>
            <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', overflow: 'hidden' }}>
                {COLS.map((col, i, arr) => {
                    const t = TIPO[col.tipoKey];
                    return (
                        <div key={col.key} style={{ padding: '18px 20px', borderRight: i < arr.length - 1 ? '1px solid #f0f0f0' : 'none', overflowY: 'auto' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, paddingBottom: 10, borderBottom: `1.5px solid ${t.color}22` }}>
                                <span style={{ fontSize: 16, fontWeight: 700, color: t.color }}>{col.label}</span>
                                <button onClick={() => onExpand(col.key)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2 }}>
                                    <Maximize4 size={16} color={t.color} />
                                </button>
                            </div>
                            {(groups[col.key] || []).length === 0
                                ? <div style={{ fontSize: 13, color: '#ccc', textAlign: 'center', marginTop: 20 }}>Nessun evento</div>
                                : (groups[col.key] || []).map(ev => (
                                    <OraCard key={ev.id} event={ev} colore={t.color} tipoKey={col.tipoKey} onEventClick={onEventClick} />
                                ))
                            }
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function VistaEspansa({ activeCol, setActiveCol, onCollapse, oraStart, oraEnd, setOraStart, setOraEnd, navigate, onEventClick, groups }) {
    const col    = COLS.find(c => c.key === activeCol);
    const t      = TIPO[col.tipoKey];
    const eventi = groups[activeCol] || [];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 8, minHeight: 52 }}>
                <div style={{ display: 'flex', height: 52, alignItems: 'flex-end' }}>
                    {COLS.map(c => {
                        const isActive = c.key === activeCol;
                        const ct = TIPO[c.tipoKey];
                        return (
                            <button key={c.key} onClick={() => setActiveCol(c.key)} style={{
                                padding: '0 16px', height: '100%', fontSize: 13,
                                fontWeight: isActive ? 700 : 500, border: 'none',
                                borderBottom: isActive ? `2.5px solid ${ct.color}` : '2.5px solid transparent',
                                background: 'transparent', color: isActive ? ct.color : '#aaa',
                                cursor: 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap',
                            }}>{c.label}</button>
                        );
                    })}
                </div>
                <TimeControls oraStart={oraStart} oraEnd={oraEnd} setOraStart={setOraStart} setOraEnd={setOraEnd} navigate={navigate}
                    collapseIcon={
                        <button onClick={onCollapse} style={{ ...navBtn, color: '#666' }}>
                            <CollapseIcon color="#666" />
                        </button>
                    }
                />
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
                {eventi.length === 0
                    ? <div style={{ fontSize: 13, color: '#ccc', textAlign: 'center', marginTop: 40 }}>Nessun evento</div>
                    : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0 20px' }}>
                            {eventi.map(ev => (
                                <OraCard key={ev.id} event={ev} colore={t.color} tipoKey={col.tipoKey} onEventClick={onEventClick} />
                            ))}
                        </div>
                    )
                }
            </div>
        </div>
    );
}

function normalizeOra(ora) {
    if (!ora) return null;
    // "09:30" → "09:00" — snap to the hour list
    const hh = ora.substring(0, 2);
    const snapped = `${hh}:00`;
    return ORE.includes(snapped) ? snapped : null;
}

export default function VistaOra({ eventi = [], selectedDate, oraIniziale, onRangeChange, onEventClick }) {
    const initial = normalizeOra(oraIniziale);
    const [oraStart,    setOraStart]    = useState(initial || '10:00');
    const [oraEnd,      setOraEnd]      = useState(() => {
        const start = initial || '10:00';
        const idx = ORE.indexOf(start);
        return ORE[Math.min(idx + 1, ORE.length - 1)] || '11:00';
    });
    const [expandedCol, setExpandedCol] = useState(null);

    // Sync when arriving from VistaGiorno with a clicked hour
    useEffect(() => {
        const snap = normalizeOra(oraIniziale);
        if (!snap) return;
        const idx = ORE.indexOf(snap);
        setOraStart(snap);
        setOraEnd(ORE[Math.min(idx + 1, ORE.length - 1)] || snap);
    }, [oraIniziale]);

    // Notifica il range (giorno corrente)
    useEffect(() => {
        const d = selectedDate || new Date();
        const { da, a } = toDayRange(d);
        onRangeChange && onRangeChange(da, a);
    }, [selectedDate]); // eslint-disable-line react-hooks/exhaustive-deps

    const navigate = (dir) => {
        const idx = ORE.indexOf(oraStart);
        const n = idx + dir;
        if (n >= 0 && n < ORE.length - 1) { setOraStart(ORE[n]); setOraEnd(ORE[n + 1]); }
    };

    const groups = groupByType(eventi, oraStart, oraEnd);

    const dataLabel = (selectedDate || new Date()).toLocaleDateString('it-IT', {
        weekday: 'long', day: 'numeric', month: 'long',
    });

    if (expandedCol) return (
        <VistaEspansa
            activeCol={expandedCol} setActiveCol={setExpandedCol}
            onCollapse={() => setExpandedCol(null)}
            oraStart={oraStart} oraEnd={oraEnd}
            setOraStart={setOraStart} setOraEnd={setOraEnd}
            navigate={navigate} onEventClick={onEventClick}
            groups={groups}
        />
    );

    return (
        <VistaNormale
            oraStart={oraStart} oraEnd={oraEnd}
            setOraStart={setOraStart} setOraEnd={setOraEnd}
            navigate={navigate} onExpand={setExpandedCol}
            onEventClick={onEventClick} groups={groups}
            dataLabel={dataLabel}
        />
    );
}

const navBtn = {
    background: '#fff', border: '1px solid #e0e0e0', borderRadius: 4,
    width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
};
